<script>
import BaseButton from '@/components/_base-button.vue'
import VuetifyTextClass from '@/constants/core/VuetifyTextClass'

export default {
  name: 'BaseModal',
  components: {
    BaseButton,
  },
  model: {
    prop: 'show',
    event: 'input',
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    borderRadius: {
      type: String,
      default: 'xl',
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    hideHeaderDivider: {
      type: Boolean,
      default: false,
    },
    hideActions: {
      type: Boolean,
      default: false,
    },
    hideActionsDivider: {
      type: Boolean,
      default: false,
    },
    hideCancel: {
      type: Boolean,
      default: false,
    },
    hidePadding: {
      type: Boolean,
      default: false,
    },
    resizeDuration: {
      type: String,
      default: '0.3s',
    },
  },
  data: () => ({
    h6: VuetifyTextClass.h6,
  }),
  computed: {
    isOpen: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    handleOutsideClick() {
      if (!this.persistent) {
        this.close()
      }
    },
    close() {
      this.isOpen = false
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="isOpen"
    v-bind="{ ...$attrs, persistent }"
    :content-class="`rounded-${borderRadius} transitions`"
    @click:outside="handleOutsideClick"
  >
    <v-card :rounded="borderRadius" class="transitions" v-bind="{ ...$attrs }">
      <template v-if="!hideHeader">
        <v-card-title :class="{ 'pa-6': !$slots.header }">
          <slot name="header">
            <span :class="h6">{{ title }}</span>
            <v-spacer />

            <BaseButton icon fab small @click="close">
              <v-icon dark> mdi-close </v-icon>
            </BaseButton>
          </slot>
        </v-card-title>
        <v-divider v-if="!hideHeaderDivider" />
      </template>
      <v-card-text :class="{ 'pa-0': hidePadding }"><slot /></v-card-text>
      <template v-if="!hideActions">
        <v-divider v-if="!hideActionsDivider" />
        <v-card-actions
          :class="{ 'px-6 py-4': !$slots.header }"
          class="d-flex justify-end"
        >
          <BaseButton v-if="!hideCancel" text depressed @click="close">{{
            $t('general.cancelBtnText')
          }}</BaseButton>
          <slot name="actions"> </slot>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.transitions {
  overflow: hidden;
  transition: width 0.3s ease, max-height 0.3s ease;
}
</style>
